export default __webpack_public_path__ + "static/media/042-punch.05c58cfa.svg";